import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewInvitationsComponent } from './review-invitations/review-invitations.component';
import { MobileAppSubscriptionsComponent } from './mobile-app-subscriptions/mobile-app-subscriptions.component';
import { DistributorRoutingModule } from './distributor-routing.module';
import { MaterialsModule } from '../materials/materials.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageCropperComponent } from 'ngx-image-cropper';
//import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { ChangeImageComponent } from '../shared/change-image/change-image.component';
import { AddEditSubscriptionComponent } from './mobile-app-subscriptions/add-edit-subscription/add-edit-subscription.component';
import { RenewSubscriptionsComponent } from './mobile-app-subscriptions/renew-subscriptions/renew-subscriptions.component';
import { InviteManufacturerComponent } from './review-invitations/invite-manufacturer/invite-manufacturer.component';
import { EllipsisTooltipDirective } from '../shared/directives/ellipsis-tooltip.directive';
@NgModule({
    declarations: [ReviewInvitationsComponent, MobileAppSubscriptionsComponent, InviteManufacturerComponent,
        RenewSubscriptionsComponent, AddEditSubscriptionComponent],
    imports: [
        DistributorRoutingModule,
        MaterialsModule,
        FormsModule,
        ImageCropperComponent,
        ReactiveFormsModule,
        // MatPasswordStrengthModule,
        CommonModule,
        EllipsisTooltipDirective
    ]
})
export class DistributorModule { }
